module.exports = __webpack_public_path__ + "static/media/232BL.7730c34f.jpg";